import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AppShell from "./components/AppShell/AppShell";
import Home from "./page/Home/Home";
import Login from "./page/Login/Login";
import Register from "./page/Register/Register";
import Crops from "./page/Crops/Crops";
import CropDetail from "./page/Crops/CropDetail";
import CropRegister from "./page/Crops/CropRegister";
import Board from "./page/Board/Board";
import Profile from "./page/Profile/Profile";
import NewsInner from "./page/NewsInner/NewsInner";
import NotFound from "./page/NotFound/NotFound";

const ProtectedLayout = () => {
  const { user, checking } = useAuth();

  if (checking) {
    return <div className="boot-screen">생존자 인증 기록 확인 중...</div>;
  }

  return user ? <AppShell /> : <Navigate to="/login" replace />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route element={<ProtectedLayout />}>
      <Route path="/" element={<Home />} />
      <Route path="/crops" element={<Crops />} />
      <Route path="/crops/register" element={<CropRegister />} />
      <Route path="/crops/:id" element={<CropDetail />} />
      <Route path="/news/:id" element={<NewsInner />} />
      <Route path="/board" element={<Board />} />
      <Route path="/profile" element={<Profile />} />
    </Route>
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
